export const APIPREFIX = process.env.VUE_APP_CDN || "";
export const APISOCKET = "http://192.168.22.121:3100";
